export const PSD2_SP1 = {
  CRS_AUTHORIZE: 'CRS_AUTHORIZE',
  CRS_AUTHORIZE_SUCCESS: 'CRS_AUTHORIZE_SUCCESS',
  CRS_AUTHORIZE_FAIL: 'CRS_AUTHORIZE_FAIL'
};
